module.exports = __webpack_public_path__ + "img/glow-green-small.cc80ad19.png";